import { Application } from "@hotwired/stimulus";

import MapController from "../components/form/map_controller.js";
import ClubMapController from "../components/club_map/component_controller.js";
import DynamicMapController from "../components/map/component_controller.js";
import MultiPinMapController from "../components/map/multi_pin_controller.js";
import SiteGuideController from "../components/site_guide/component_controller.js";
import RecordingAreaController from "./controllers/recording_area_controller";

const application = Application.start();
application.register("map", MapController);
application.register("club-map", ClubMapController);
application.register("dynamic-map", DynamicMapController);
application.register("multi-pin-map", MultiPinMapController);
application.register("site-guide", SiteGuideController);
application.register("recording-area", RecordingAreaController);
